import { render } from "./University.vue?vue&type=template&id=39d1ad60&scoped=true"
import script from "./University.vue?vue&type=script&lang=js"
export * from "./University.vue?vue&type=script&lang=js"

import "./University.vue?vue&type=style&index=0&id=39d1ad60&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d1ad60"]])

export default __exports__